import axios from '|/helpers/axios';

export const getVehicleIdFromStockNumber = (stockNumber: string) =>
  axios
    .get<number>(
      `${process.env.API_URL}/api/v1/vehicle/getvehicleid/${stockNumber}`
    )
    .then(res => res.data);
